import { css } from '@emotion/core';

const styles = (theme, width) => ({
  container: css`
    width: ${width}px;
    display: inline-flex;
    align-items: center;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    justify-content: space-between;
    background-color: ${theme && theme.vds
      ? theme.vds.secondary
      : '#fff'} !important;
    color: ${theme && theme.vds ? theme.vds.actionSecondary : ''} !important;
    ${theme && theme.classes ? theme.classes.typography.color.misc.white : ''};
    min-height: 2.5rem;

    & button:focus {
      outline: 1px dashed #fff !important;
    }

    span {
      word-break: break-all;
    }
  `
});

export default styles;
